import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../lib/api";

export function useProductReviews(slug) {
  return useQuery({
    queryKey: ["reviews", "product", slug],
    queryFn: async () => (await api.get(`/reviews/product/${slug}`, { params: { limit: 50 } })).data.reviews,
    enabled: !!slug,
  });
}

export function useSubmitReview() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post("/reviews", data).then((r) => r.data),
    // Not invalidated on success — a freshly-submitted review is
    // unapproved and wouldn't show up in the approved list anyway; it
    // only becomes visible once admin approval invalidates this query.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["admin", "reviews"] }),
  });
}
